import React from 'react'
import classnames from 'classnames'
import * as styles from './layout.styles'
import { propStyles } from './util'

export const Row = ({ children, ...props }) => {
  const { classes, props: newprops } = propStyles(props)
  return (
    <div className={classnames(styles.row, classes)} {...newprops}>
      {children}
    </div>
  )
}
